export default {
  data: {
    picture: null
  },

  // Methods that you need, for e.g fetching data from server etc.

  fetchData() {
    // fetch logic
  }
};
